import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import './styles/global.scss'
import { resolveImageUrl, resolveImageList } from './utils/media'

Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.mixin({
  methods: {
    resolveImageUrl,
    resolveImageList
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
